<template>
  <div>
    <flowy-drag-handle class="grab">
      <b-card class="custom-accordion shadow-none mb-1">
        <slot></slot>
        {{ title }}
      </b-card>
    </flowy-drag-handle>
  </div>
</template>

<script>
export default { props: ["remove", "node", "icon", "title", "description"] };
</script>

<style scoped>
.card-body {
  padding: 10px !important;
}
</style>
